//
//
//
//
//
//

import wx from "@/assets/utils/wx.js";
export default {
  name: "app",
  created() {
    let that=this;
    if (this.GLOBAL.isWx) {
      // 微信jssdk 配置
      wx.wxConfig(
        false,
        {
          title: "百馆百址", // 分享标题
          link: window.location.href, // 分享链接
          desc: window.location.href, // 分享描述
          imgUrl: "" // 分享图标
        },
        function() {
          //分享成功后的回调函数
          console.log("分享成功");
        }
      );
    } else {
      let geolocation = new qq.maps.Geolocation(
        "3HQBZ-TEX3X-NJF43-73EDL-RUD7H-NVBJM",
        "myweb"
      );
      // 单次定位 获取定位成功事件
      let showPosition = function(position) {
        console.log("定位成功");
        console.log(position);
        localStorage.setItem("lng", position.lng);
        localStorage.setItem("lat", position.lat);
      };
      // 单次定位 获取定位失败事件
      let showErr = function() {
        console.log("首次定位失败");
        that.$vux.toast.text("获取定位失败", "bottom");
      };
      geolocation.getLocation(showPosition, showErr, { timeout: 8000 });
    }
  }
};



// WEBPACK FOOTER //
// ./src/App.vue